import * as React from 'react';
import TextField, { TextFieldProps } from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';
import { fontFamilies } from '../../theme/text';

const CssTextField = withStyles({
  root: {
    width: '100%',

    '& .MuiFormLabel-root.Mui-disabled': {
      fontFamily: fontFamilies.heading,
      fontSize: 11,
      fontWeight: 300,
      color: '#4f4f4f'
    },
    '& .MuiInputBase-input': {
      color: '#000000',
      fontFamily: fontFamilies.body,
      fontWeight: 300,
      letterSpacing: '0.3px',
      fontSize: 14,
      paddingTop: 0
    },
    '& .MuiInput-underline.Mui-disabled:before': {
      borderBottomStyle: 'none'
    }
  }
})(TextField);

const HeaderTextField = withStyles({
  root: {
    width: '100%',

    '& .MuiFormLabel-root.Mui-disabled': {
      fontFamily: fontFamilies.body,
      fontSize: 12,
      fontWeight: 300,
      color: '#4f4f4f'
    },
    '& .MuiInputBase-input': {
      color: '#000000',
      fontFamily: fontFamilies.heading,
      fontWeight: 500,
      letterSpacing: '0.3px',
      fontSize: 16,
      paddingTop: 0
    }
  }
})(TextField);

type Props = TextFieldProps & {
  isheader?: string;
};

/**
 * DisabledInput
 * @function - Component for a disabled input, used to display text with a label
 */
const DisabledInput = (props: Props) => {
  if (props.isheader) {
    return <HeaderTextField {...props} />;
  }
  return <CssTextField {...props} />;
};

export default DisabledInput;
